var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-market-jetton-percent",class:`card-jetton-indicator--${_vm.color}`},[_c('span',[_vm._v(_vm._s(_vm.sign)+_vm._s(_vm.value)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }